"use client";

import { cn } from "@/lib/utils";
import { useFallbackTrigger } from "./useFocusAfterFallback";
import { POPOVER_TRIGGER_CLASS } from "./overlay.constants";
import { createLazyOverlay } from "./createLazyOverlay";
import type { ComponentProps, ComponentPropsWithRef, ReactElement, ReactNode } from "react";
import type { PopoverPanel as PopoverPanelComponent } from "./PopoverPanel";
export type RenderPopoverTrigger = (attrs: ComponentPropsWithRef<"button">) => ReactElement;
type PopoverProps = Omit<ComponentProps<typeof PopoverPanelComponent>, "fallbackRef" | "renderTrigger"> & {
  trigger: ReactNode;
  triggerClassName?: string;
};
const LazyPopoverPanel = createLazyOverlay<ComponentProps<typeof PopoverPanelComponent> & {
  fallbackHandlers: ReturnType<typeof useFallbackTrigger>["fallbackHandlers"];
}>({
  name: "popover",
  load: () => import("./PopoverPanel"),
  exportName: "PopoverPanel",
  renderFallback: props => <div className={cn("relative", props.className)}>
            {props.renderTrigger({
      ...props.fallbackHandlers,
      "aria-haspopup": "dialog",
      // boolean-naming-exempt: external contract — ARIA attribute name
      "aria-expanded": false
    })}
        </div>
});
export function Popover(props: PopoverProps) {
  const {
    fallbackRef,
    fallbackHandlers
  } = useFallbackTrigger();
  const renderTrigger: RenderPopoverTrigger = attrs => <button type="button" aria-label={props.label} disabled={props.disabled} className={cn(POPOVER_TRIGGER_CLASS, props.triggerClassName)} {...attrs} data-sentry-component="renderTrigger" data-sentry-source-file="Popover.tsx">
            {props.trigger}
        </button>;
  return <LazyPopoverPanel {...props} fallbackRef={fallbackRef} fallbackHandlers={fallbackHandlers} renderTrigger={renderTrigger} data-sentry-element="LazyPopoverPanel" data-sentry-component="Popover" data-sentry-source-file="Popover.tsx" />;
}